import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CookieService {

  constructor() { }

  setarNaSessao(nome: string, valor: string) {
    let cookie = `${nome}=${encodeURI(valor)}; Secure; SameSite=Strict; Path=/`;
    document.cookie = cookie;
  }

  remover(nome: string) {
    let cookie = `${nome}=; Secure; SameSite=Strict; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT`;
    document.cookie = cookie;
  }

  consultar(nome: string): string {
    let cookie = document.cookie;
    let entradas = cookie.split(';');
    let nomeParaBusca = nome + '=';
    let valor = '';

    for(let x = 0; x < entradas.length; x++) {
      let c = entradas[x];
      
      if(c.indexOf(nomeParaBusca) >= 0) {
        valor = decodeURI(c.replace(nomeParaBusca, ''));
        break;
      }
    }

    return valor;
  }
}
